module.exports = __webpack_public_path__ + "media/images/version_merge/target_couple-76fe3cf702dd139fe594a04c917c5f8c.jpg";